<loading-animation class="cl-layout-fill"
                   size="large"
                   *ngIf="!isReady"
                   valign></loading-animation>
<ng-container *ngIf="isReady">
    <div class="grid-view-filters"
         *ngIf="!wizardView"
         fxLayout="row wrap"
         [formGroup]="deviceStatusFormGroup">
        <mat-form-field>
            <mat-label>Wildcard</mat-label>
            <input matInput
                   [formControl]="wildcardFormControl"
                   [class.text-color-white]="isDarkTheme()"
                   (keyup)="search()" />
        </mat-form-field>

        <mat-form-field>
            <mat-label>Job Number</mat-label>
            <input matInput
                   [formControl]="jobNumberFormControl"
                   [class.text-color-white]="isDarkTheme()"
                   (keyup)="search()" />
        </mat-form-field>

        <advanced-dropdown *ngIf="!hideFields && deviceStatusFilters.showCustomerDropdown && deviceStatusFilters.customers.visible"
                           class="caslink"
                           [data]="deviceStatusFilters.customers"
                           [(model)]="query.customerId"
                           (change)="deviceStatusFilters.customerHandler()"
                           itemHeight="35"
                           width="300">
        </advanced-dropdown>

        <mat-form-field *ngIf="deviceStatusFilters.showIsCertifiedFilter"
                        fxFlex.sm="20"
                        fxFlex.xs="20"
                        fxFlex.gt-sm="10">
            <mat-label>Is Certified Location</mat-label>
            <mat-select [formControl]="isCertifiedFormControl"
                        (selectionChange)="deviceStatusFilters.certifiedHandler($event)">
                <mat-option [value]="null">
                    Either
                </mat-option>
                <mat-option [value]="false">
                    No
                </mat-option>
                <mat-option [value]="true">
                    Yes
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="deviceStatusFilters.showIsAirQualityExcellenceFilter"
                        fxFlex.sm="20"
                        fxFlex.xs="20"
                        fxFlex.gt-sm="10">
            <mat-label>Is Air Quality Excellence Location</mat-label>
            <mat-select [formControl]="isAirQualityExcellenceFormControl"
                        (selectionChange)="deviceStatusFilters.airQualityExcellenceHandler($event)">
                <mat-option [value]="null">
                    Either
                </mat-option>
                <mat-option [value]="false">
                    No
                </mat-option>
                <mat-option [value]="true">
                    Yes
                </mat-option>
            </mat-select>
        </mat-form-field>

        <advanced-dropdown *ngIf="!hideFields && deviceStatusFilters.locations.visible"
                           class="caslink"
                           [data]="deviceStatusFilters.locations"
                           [(model)]="query.locationId"
                           (change)="deviceStatusFilters.locationHandler()"
                           itemHeight="35"
                           width="350">
        </advanced-dropdown>

        <advanced-dropdown *ngIf="!hideFields"
                           class="caslink"
                           [data]="deviceStatusFilters.modules"
                           [(model)]="query.moduleId"
                           (change)="search()"
                           itemHeight="35"
                           width="425">
        </advanced-dropdown>

        <advanced-dropdown class="caslink"
                           [data]="deviceStatusFilters.categories"
                           [(model)]="hardwareCategory"
                           (change)="categoryHandler($event)"
                           itemHeight="35"
                           width="425">
        </advanced-dropdown>

        <advanced-dropdown class="caslink"
                           [data]="deviceStatusFilters.reportTemplates"
                           [(model)]="query.reportTemplateId"
                           (change)="search()"
                           itemHeight="35"
                           width="425">
        </advanced-dropdown>
    </div>
    <cl-resizable-map [height]="defaultMapHeight"
                      *ngIf="isMapEnabled"
                      [pins]="pins">
    </cl-resizable-map>
    <cas-table [data]="data"
               [config]="tableConfig"
               (getData)="getData()"
               [disableAdd]="true">
    </cas-table>
</ng-container>